/**
 * Created by Josef Jurca on 24/04/17.
 */
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import {getInstance as getDataSources} from 'datasources';
import {
    hideModal,
    setStatus as setModalStatus,
    ModalStatus
} from 'store/actions/modal';
import {getSettings} from 'store/actions/pages/settings';
import ErrorCodes from 'errorcodes';

import {
    subscribe,
} from 'store/actions/payment';
// Action types
const ActionTypes = {
        SET_EDIT_USER_MODAL_STATUS: 'SET_EDIT_USER_MODAL_STATUS',
        SET_EDIT_USER_INITIAL_DATA: 'SET_EDIT_USER_MODAL_DATA',
        SET_EDIT_USER_DATA: 'SET_EDIT_USER_DATA',
        SET_EDIT_USER_MODAL_ERROR: 'SET_EDIT_USER_MODAL_ERROR'
    },

    // Status values
    EditUserModalStatus = {
        INITIAL: 'initial',
        REQUEST_SUCCESS: 'request-success',
        REQUEST_FAILURE: 'request-failure'
    };

/**
 * Set status action.
 *
 * @param {string} status - New status of the component.
 * @returns {Object} Action type and the new status.
 */
function setStatus (status) {

    return {
        type: ActionTypes.SET_EDIT_USER_MODAL_STATUS,
        status
    };
}

/**
 * Set error action.
 *
 * @param {Object} error - Error object with reason message.
 * @returns {Object} Action type and error object.
 */
function setError (error) {
    return {
        type: ActionTypes.SET_EDIT_USER_MODAL_ERROR,
        error
    };
}

/**
 * Set initial form data action.
 *
 * @param {Object} [initialValues] - Data of form.
 * @returns {Object} Action type, user's name and email.
 */
function setInitialFormData (initialValues) {
    return {
        type: ActionTypes.SET_EDIT_USER_INITIAL_DATA,
        initialValues
    };
}

/**
 * Set form data action.
 *
 * @param {Object} [formData] - Data of form.
 * @returns {Object} Action type, user's name and email.
 */
function setFormData (formData) {
    return {
        type: ActionTypes.SET_EDIT_USER_DATA,
        formData
    };
}

/**
 * Attempt to register action.
 *
 * @returns {Promise} Response to the request.
 */
function attemptEditUser (userDataForUpdate = false) {
    return (dispatch, getState) => {
        let dataSources = getDataSources(),
            registerFormData = _get(getState(), ['edituser', 'formData']);

        dispatch(setModalStatus(ModalStatus.LOADING));
        
        if(userDataForUpdate) {
            registerFormData = userDataForUpdate;
        }

        return dataSources.updateUser(registerFormData)
            .then(() => {
                if(userDataForUpdate) {
                    dispatch(subscribe());
                } else {
                    dispatch(setError(null));
                    dispatch(setStatus(EditUserModalStatus.REQUEST_SUCCESS));
                    dispatch(hideModal());
                    dispatch(getSettings());
                }
            })
            .catch((error) => {
                const {result: {error: { code }}} = error;

                code === ErrorCodes.USER_EXISTS
                    ? dispatch(setError('settings.errors.edit.user-exists'))
                    : dispatch(setError('settings.errors.server-error'));

                dispatch(setStatus(EditUserModalStatus.REQUEST_FAILURE, 'ERROR'));
                dispatch(setModalStatus(ModalStatus.ERROR));
            });
    };
}

// Exposed elements of the actions file.
export {
    ActionTypes,
    EditUserModalStatus,
    setInitialFormData,
    setFormData,
    setStatus,
    setError,
    attemptEditUser
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modals/edituser.js